<div class="full-screen">
    <div class="column">
        <h1>404</h1>
        <h2>Ooops... 404!</h2>
        <h4>{{'The page you requested could not be found' | translate}}.</h4>

        <a routerLink="/dashboard">{{'Back to Dashboard' | translate}}</a>
    </div>
</div>